import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('base')



export const verifyEmail = (email:string) => {
    return axiosInstance.post('/users/update-email', { email })
}
